<template>
  <div id="visualization">

    <transition name="fade">
      <RingLoader v-if="performingRequest" :color="this.spinnerColor" :size="this.spinnerSize"></RingLoader>
    </transition>

    <!-- Posts Feed in Dashboard Style -->
    <div class="container-fluid" v-if="style == 'dashboard' && showViz == true">
      <DashboardHome></DashboardHome>
    </div><!-- /.container-fluid -->
    <!-- Posts Feed in Masonry Style -->
    <PostsMasonry v-if="style == 'grid' && showViz == true"></PostsMasonry>
    <!-- Posts Feed in Map Style -->
    <PostsMap v-if="style == 'map' && showViz == true"></PostsMap>
    <!-- Posts Feed in Timeline Style -->
    <PostsTimeline v-if="style == 'timeline' && showViz == true"></PostsTimeline>

  </div><!-- #/visualization -->
</template>

<script>
  import { mapState } from 'vuex'
  import DashboardHome from './DashboardHome.vue'
  import PostsMasonry from './PostsMasonry.vue'
  import PostsMap from './PostsMap.vue'
  import PostsTimeline from './PostsTimeline.vue'
  import RingLoader from 'vue-spinner/src/RingLoader.vue'

  export default {
    components: { DashboardHome, PostsMasonry, PostsMap, PostsTimeline, RingLoader },
    data() {
      return {
        style: '',
        mode: '',
        id: '',
        showViz: false,
        performingRequest: true,
        spinnerColor: '#2674a3',
        spinnerSize: '50px'
      }
    },
    computed: {
      ...mapState(['posts'])
    },
    created: function() {

      if (this.$route.params.style) {
        this.style = this.$route.params.style
      }
      if (this.$route.params.mode) {
        this.mode = this.$route.params.mode
      }
      if (this.$route.params.id) {
        this.id = this.$route.params.id
      }

      // Check to see if we are in a visualization, if so, set the globa posts to those in the list id from the URL
      if (this.mode == 'list') {
        this.$store.dispatch('getListPosts', this.id)
      }
      if (this.mode == 'user') {
        this.$store.dispatch('getUsersPosts', this.id)
      }
      let self = this
      setTimeout(function() {
        self.showViz = true
        self.performingRequest = false
      }, 3000)

    },
    methods: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Visualization.vue